import $ from "jquery";
import _ from "lodash";
import React, { useState } from "react";
import ReactDOM from "react-dom";
import interact from "interactjs";

import "./index.css";
import "./lesson2.css";

import { CardList, Tabs, ControllerFrame, PlayButton } from "./components";
import { Lesson2Player, Card, SamplePlayer } from "./classes";
import * as serviceWorker from "./serviceWorker";

export const samplePlayer = new SamplePlayer();

export const lesson2Player = new Lesson2Player();

export const lesson2Cards = [
  new Card(
    "ア",
    ["ドン", "ドコ"],
    [
      `${process.env.PUBLIC_URL}/a_2_4.mp3`,
      `${process.env.PUBLIC_URL}/a_2_4.wav`,
    ],
    "./a.png"
  ),
  new Card(
    "イ",
    ["ドン", "ドン"],
    [
      `${process.env.PUBLIC_URL}/i_2_4.mp3`,
      `${process.env.PUBLIC_URL}/i_2_4.wav`,
    ],
    "./i.png"
  ),
  new Card(
    "ウ",
    ["ドン", "ウン"],
    [
      `${process.env.PUBLIC_URL}/u_2_4.mp3`,
      `${process.env.PUBLIC_URL}/u_2_4.wav`,
    ],
    "./u.png"
  ),
  new Card(
    "エ",
    ["ドコ", "ドン"],
    [
      `${process.env.PUBLIC_URL}/e_2_4.mp3`,
      `${process.env.PUBLIC_URL}/e_2_4.wav`,
    ],
    "./e.png"
  ),
  new Card(
    "オ",
    ["ス", "コ", "ドン"],
    [
      `${process.env.PUBLIC_URL}/o_2_4.mp3`,
      `${process.env.PUBLIC_URL}/o_2_4.wav`,
    ],
    "./o.png"
  ),
  new Card(
    "カ",
    ["ドコ", "ドコ"],
    [
      `${process.env.PUBLIC_URL}/ka_2_4.mp3`,
      `${process.env.PUBLIC_URL}/ka_2_4.wav`,
    ],
    "./ka.png"
  ),
];

ReactDOM.render(
  <CardList cards={lesson2Cards} />,
  document.getElementById("react-lesson2-cards")
);

function dragMoveListener(event) {
  // console.log("drag move listener", event);
  var target = event.target;
  // keep the dragged position in the data-x/data-y attributes
  var x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
  var y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;

  // translate the element
  target.style.webkitTransform = target.style.transform =
    "translate(" + x + "px, " + y + "px)";

  // update the posiion attributes
  target.setAttribute("data-x", x);
  target.setAttribute("data-y", y);
}

// this function is used later in the resizing and gesture demos
window.dragMoveListener = dragMoveListener;

function listener(event) {
  console.log(event.type, event.pageX, event.pageY);
}

function dragEndListener(event) {
  // event.stopPropagation();
  const dom = $(event.target);
  if (dom.hasClass("placed")) {
    lesson2Player.setCard(parseInt(dom.data("zone-id")), null);
    dom.remove();
  }
  dom.removeAttr("data-x");
  dom.removeAttr("data-y");
  dom.removeAttr("style");
  console.log("dragEndListener");
}

document.addEventListener("DOMContentLoaded", () => {
  interact(".dropzone").dropzone({
    overlap: 0.7,

    // listen for drop related events:

    ondropactivate: function (event) {
      // console.log("on drop activate", event);
      // add active dropzone feedback
      event.target.classList.add("drop-active");
    },

    ondragenter: function (event) {
      // console.log("on drag enter", event);
      var draggableElement = event.relatedTarget;
      var dropzoneElement = event.target;

      // feedback the possibility of a drop
      dropzoneElement.classList.add("drop-target");
      draggableElement.classList.add("can-drop");
    },

    ondragleave: function (event) {
      // console.log("on drag leave", event);
      // remove the drop feedback style
      event.target.classList.remove("drop-target");
      event.relatedTarget.classList.remove("can-drop");
    },

    ondrop: function (event) {
      const movedDom = $(event.relatedTarget);
      movedDom.removeAttr("data-x");
      movedDom.removeAttr("data-y");
      movedDom.removeAttr("style");
      movedDom.removeClass(["can-drop"]);
      const cardName = movedDom.data("card-name");

      const placedDom = $(event.currentTarget);
      placedDom.empty();
      const zoneId = parseInt(placedDom.data("zone-id"));
      const cloneDom = movedDom.clone();
      cloneDom.addClass("placed");
      cloneDom.attr("data-zone-id", zoneId);
      placedDom.append(cloneDom);

      const card = _.find(lesson2Cards, function (card) {
        return card.name === cardName;
      });
      lesson2Player.setCard(zoneId, card);
      console.log("ondrop");
    },

    ondropdeactivate: function (event) {
      // console.log("on drop deactivate", event);
      // remove active dropzone feedback
      event.target.classList.remove("drop-active");
      event.target.classList.remove("drop-target");
    },
  });

  interact(".draggable").draggable({
    inertia: true,
    modifiers: [
      interact.modifiers.restrictRect({
        endOnly: true,
      }),
    ],
    autoScroll: true,
    // dragMoveListener from the dragging demo above
    onstart: listener,
    onmove: dragMoveListener,
    onend: dragEndListener,
  });

  interact(".draggable").on("tap", function (event) {
    const cardDom = $(event.currentTarget);
    const cardName = cardDom.data("card-name");
    const card = _.find(lesson2Cards, function (card) {
      return card.name === cardName;
    });
    samplePlayer.play(card.audioSrc);
  });
});

function Controller() {
  const [state, setState] = useState({ tempo: undefined });

  function createHandler(tempo) {
    return function () {
      for (let [, card] of Object.entries(lesson2Player.placedCardMap)) {
        if (card === null) {
          window.alert("カードは4まいすべておいてください。");
          return;
        }
      }

      if (tempo === state.tempo) {
        lesson2Player.stop();
        setState({ tempo: undefined });
      } else {
        lesson2Player.play(() => {
          setState({ tempo: undefined });
        });
        setState({ tempo });
      }
    };
  }

  return (
    <ControllerFrame>
      <PlayButton
        label="さいせい"
        isPlaying={state.tempo === "さいせい"}
        onClick={createHandler("さいせい")}
        width={180}
      />
      <PlayButton
        label="カードをリセット"
        isPlaying={state.tempo === "ちょっとゆっくり"}
        onClick={() => {
          lesson2Player.resetCard();
        }}
        disableIcon={true}
        width={180}
      />
    </ControllerFrame>
  );
}

ReactDOM.render(
  <React.StrictMode>
    <Controller />
  </React.StrictMode>,
  document.getElementById("react-controller")
);

ReactDOM.render(
  <React.StrictMode>
    <Tabs currentPage="lesson2" />
  </React.StrictMode>,
  document.getElementById("react-tabs")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
